'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { PauseSolidXs } from '@lichtblick/photon/icons/symbols/pause-solid-xs';
import { PlayXs } from '@lichtblick/photon/icons/symbols/play-xs';
import classNames from 'classnames';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { AImage } from '../AImage';
import styles from './logo-carousel.module.css';
export const LogoCarousel = ({ borderBottom, borderTop, logos })=>{
    const viewRef = useRef(null);
    const [looping, setLooping] = useState(false);
    const [reducedMotion, setReducedMotion] = useState(true);
    const [requestedPlaying, setRequestedPlaying] = useState();
    const playing = requestedPlaying ?? !reducedMotion;
    useEffect(()=>{
        const motionPreferenceObserver = window.matchMedia('(prefers-reduced-motion: reduce)');
        const handleMotionPreference = ()=>setReducedMotion(motionPreferenceObserver.matches);
        handleMotionPreference();
        motionPreferenceObserver.addEventListener('change', handleMotionPreference);
        return ()=>{
            motionPreferenceObserver.removeEventListener('change', handleMotionPreference);
        };
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: must be triggered on changing `logos`
    useLayoutEffect(()=>{
        const determineLooping = ()=>setLooping(viewRef.current !== null && viewRef.current.scrollWidth > viewRef.current.clientWidth * (viewRef.current.classList.contains(styles.looping) ? 2 : 1));
        determineLooping();
        window.addEventListener('resize', determineLooping);
        return ()=>{
            window.removeEventListener('resize', determineLooping);
        };
    }, [
        logos
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        style: {
            '--item-count': logos.length
        },
        children: [
            borderTop && /*#__PURE__*/ _jsx("hr", {}),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames(styles.view, looping && styles.looping, playing && styles.playing),
                        ref: viewRef,
                        children: /*#__PURE__*/ _jsxs("ul", {
                            className: styles.list,
                            children: [
                                logos.map((item)=>/*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(AImage, {
                                            ...item
                                        })
                                    }, item._uid)),
                                looping && logos.map((item)=>/*#__PURE__*/ _jsx("li", {
                                        "aria-hidden": true,
                                        className: styles.copy,
                                        children: /*#__PURE__*/ _jsx(AImage, {
                                            ...item
                                        })
                                    }, `${item._uid}_copy`))
                            ]
                        })
                    }),
                    looping && /*#__PURE__*/ _jsx("div", {
                        className: styles['play-button'],
                        children: /*#__PURE__*/ _jsx(BoxCTA, {
                            ariaLabel: playing ? 'Logo-Karusell anhalten' : 'Logo-Karusell starten',
                            as: "button",
                            leftSlot: playing ? /*#__PURE__*/ _jsx(PauseSolidXs, {}) : /*#__PURE__*/ _jsx(PlayXs, {}),
                            onClick: ()=>setRequestedPlaying(!playing),
                            size: "small",
                            type: "button",
                            variant: "neutral-outline"
                        })
                    })
                ]
            }),
            borderBottom && /*#__PURE__*/ _jsx("hr", {})
        ]
    });
};

//# sourceMappingURL=index.js.map